import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function ProjectSelect({ projects, value, onChange, placeholder = "Proje seçiniz", testid = "project-select", includeAll = true }) {
  return (
    <Select value={value || (includeAll ? "__all__" : "")} onValueChange={(v) => onChange(v === "__all__" ? "" : v)}>
      <SelectTrigger className="w-[240px]" data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {includeAll && <SelectItem value="__all__">Tüm Projeler</SelectItem>}
        {projects.map(p => (
          <SelectItem key={p.id} value={p.id} data-testid={`project-option-${p.code}`}>
            {p.code} — {p.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
